/* istanbul ignore file */

export { Recommendations as default } from "./Recommendations";
